/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var TimeClockFastIcon20Light = forwardRef('TimeClockFastIcon20Light', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 20 }, props),
        React.createElement("path", { d: "M3.07 9A7.002 7.002 0 0 1 17 10a7 7 0 0 1-7 7v1a8 8 0 1 0-7.938-9H3.07Z" }),
        React.createElement("path", { d: "M9.503 6.005a.5.5 0 0 1 .5.5v2.972c0 .284.16.544.415.67l2.806 1.406a.5.5 0 0 1-.448.894L9.97 11.042a1.75 1.75 0 0 1-.967-1.565V6.505a.5.5 0 0 1 .5-.5Z" }),
        React.createElement("path", { d: "M1.5 17a.5.5 0 0 0 0 1h6a.5.5 0 0 0 0-1h-6Z" }),
        React.createElement("path", { d: "M0 14.5a.5.5 0 0 1 .5-.5h5a.5.5 0 0 1 0 1h-5a.5.5 0 0 1-.5-.5Z" }),
        React.createElement("path", { d: "M1.5 11a.5.5 0 0 0 0 1H4a.5.5 0 0 0 0-1H1.5Z" })));
});
